export default __webpack_public_path__ + "static/media/K4-logo.6a0f7a09.png";